import { render, staticRenderFns } from "./ListNotify.vue?vue&type=template&id=9c46799c&"
import script from "./ListNotify.vue?vue&type=script&lang=js&"
export * from "./ListNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports